import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../../../../Layout/Layout";
import { useNavigate } from "react-router-dom";
import Constants from "../../../../common/CustomerConstants";

//Redux
import { useSelector } from "react-redux";
import { InputField } from "../../../../Components/formElements/InputField";

//Serivce
import ItemService from "../../../../services/customer_appCommonService";
const CashExpensesDetail = () => {
  const navigate = useNavigate();
  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Indent");

  let bankStatementNr = useSelector(
    (state) => state?.customer?.bankStatement?.bankStatements
  ); // User Details from Store
  const [formInputs, setFormInputs] = useState({});
  const [isCardVisible, setCardVisible] = useState(true);
  // View attachment file
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const [getDisabledStatus, setDisabledStatus] = useState(true);
  const loadFirstLevelData = async (page) => {
    if (bankStatementNr) {
      let obj = {
        documentNumber: bankStatementNr,
      };
      await ItemService.getCustInvoiceDetail(obj).then((item) => {
        console.log(item);
        if (item?.status === 200) {
          setDisabledStatus(true);
          setFormInputs(item?.data[0]);
          //   setPOLineItemsData(item?.data[0]?.items);
        } else {
          setFormInputs([]);
          console.log(">> Error: Loading getCategory");
        }
      });
    } else {
      navigate(Constants.PRESALES_INQUIRY_LIST);
    }
  };

  useEffect(() => {
    loadFirstLevelData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const firstItem =
    formInputs?.items && formInputs.items.length > 0
      ? formInputs.items[0]
      : null;

  const amountToShow = firstItem
    ? firstItem.debitAmount === 0
      ? firstItem.creditAmount
      : firstItem.creditAmount === 0
      ? firstItem.debitAmount
      : firstItem.creditAmount || firstItem.debitAmount || ""
    : "";

  // Commmon OnChange of the input scetion
  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              Bank Statement Details :{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {bankStatementNr}
              </span>
            </h2>
            <p className="subText">Bank Statement </p>
            <hr />
            {/* 01 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BS</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Bank Statement</span>
                      <span className="subHeaderTitle">Bank Statement</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Name"
                          name="companyCodeDesc"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.companyCodeDesc || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Customer Code"
                          name="customerCode"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.customerCode || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Transaction Date"
                          name="bankTransactionDate"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.bankTransactionDate || formInputs?.postingDate || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Bank Name"
                          name="bankName"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.bankName || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Transaction Type"
                          name="type"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.type || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Amount"
                          name="amount"
                          value={amountToShow}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                          placeholder="Enter Amount"
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Remarks"
                          name="remarks"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.remarks || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default CashExpensesDetail;
